import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { Router } from '@angular/router';
import { UntypedFormControl, Validators } from '@angular/forms';
import { debounce } from 'lodash';
import {
  UiUserGroupControllerService,
  UiUserControllerService,
} from 'src/app/cc-api/services';
import { USER_WRITE } from 'src/app/constants/permissions';
import { CustomToastService } from 'src/app/pages/custom-toast/custom-toast.service';
import { OnAPIErrorService } from 'src/app/services/on-api-error.service';
import { whiteSpaceInputPattern } from 'src/app/constants/inputPatterns';
import { triggerAnalyticsEvent } from 'src/app/utils/analytics/trigger-analytics';
import { AccessDeniedService } from 'src/app/services/access-denied.service';

@Component({
  selector: 'app-invite-user',
  templateUrl: './invite-user.component.html',
  styleUrls: ['./invite-user.component.scss'],
})
export class InviteUserComponent implements OnInit {
  constructor(
    private userGroupControllerService: UiUserGroupControllerService,
    private userControllerService: UiUserControllerService,
    private customToasterService: CustomToastService,
    private onAPIErrorService: OnAPIErrorService,
    private accessDeniedService: AccessDeniedService,
  ) {}
  @Input() ref: any;
  email: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.email,
    Validators.pattern(whiteSpaceInputPattern),
  ]);
  userGroup: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
  ]);
  userGroups = [];
  loadingUserGroups: boolean = false;
  USER_WRITE = USER_WRITE;
  inviteUserInProgress: boolean = false;
  userGroupIdLabelMap = {};
  hasUserGroupReadPermission: boolean;
  jsonStringify = JSON.stringify;

  ngOnInit(): void {
    this.getAllGroups();
  }

  getAllGroups() {
    this.loadingUserGroups = true;
    this.userGroupControllerService.getAllGroupUsingGET().subscribe(
      (groups) => {
        this.hasUserGroupReadPermission = true;
        this.userGroups = groups.map((group) => {
          this.userGroupIdLabelMap[group?.id] = group?.groupName;
          if (group?.groupName !== 'DEFAULT_GROUP') {
            return { label: group?.groupName, value: group?.id };
          }
        });
        this.loadingUserGroups = false;
      },
      (error) => {
        if (this.accessDeniedService.isAccessDenied(error)) {
          this.hasUserGroupReadPermission = false;
        }
        this.loadingUserGroups = false;
      },
    );
  }

  inviteUser() {
    this.inviteUserInProgress = true;
    this.userControllerService
      .inviteUsersUsingPOST({
        groupId: this.userGroup?.value,
        usersEmailList: [this.email?.value],
      })
      .subscribe(
        (resp) => {
          this.customToasterService.success(`User is successfully invited. `);
          this.inviteUserInProgress = false;
          triggerAnalyticsEvent('LEFT_NAV_INVITE_USER_INVITE_SUCCESSFUL');
          this.email.reset();
          this.userGroup.reset();
        },
        (err) => {
          this.onAPIErrorService.onAPIError(
            err?.error?.message || err?.message || `Failed to invite user`,
            err,
          );
          triggerAnalyticsEvent('LEFT_NAV_INVITE_USER_INVITE_UNSUCCESSFUL');
          this.inviteUserInProgress = false;
        },
      );
  }
}
